module.exports = __webpack_public_path__ + "img/keyboard_Ctrl.fe922573.png";